import React, { forwardRef, useRef } from 'react';
import useBlogs from '../../hooks/useBlogs';
import useIndustryExpertsBlogs from '../../hooks/useIndustryExpertBlogs';
import { default as badge1 } from '../../../images/Badges1.svg';
import { default as badge2 } from '../../../images/Badges2.svg';
import { default as badge3 } from '../../../images/Badges3.svg';
import { default as rightArrow } from '../../../images/left-arrow.svg';
import {default as girl} from '../../../images/industry_expert_blog_girl.svg';
import {default as bus} from '../../../images/industry_expert_blog_bus.svg';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import EventBlog from '../../EventBlog/EventBlog';
import './IndustryExpertsBlogs.scss';

const IndustryExpertsBlogs = forwardRef((props, ref) => {
  const data = useIndustryExpertsBlogs();
  
  const eventBlogListRef = useRef(null);
  let scrollAmount = 0;

  const openLink = () => window.open(`https://www.noissue.co/blog/tag/industry-experts/`, '_blank', 'noopener');

  const {posts : {edges : postList}} = data;

  const scrollToRight = () => {
    eventBlogListRef.current.scrollTo({
      left: scrollAmount += 800,
      behavior: 'smooth'
    });
  }

  const scrollToLeft = () => {
    eventBlogListRef.current.scrollTo({
      left: scrollAmount -= 800,
      behavior: 'smooth'
    });
  }

  return (
    <>
      {/* <div className="industry-experts-blog-container-border" ref={eventBlogListRef} /> */}
      <div className="industry-experts-blog-container" ref={ref}>
        <div className="industry-experts-blog-badges">
          <CommunityImg src={badge3} alt="badge1" />
          <CommunityImg src={badge2} alt="badge2" />
          {/* <CommunityImg src={badge1} alt="badge3" /> */}
        </div>
        <div className="industry-experts-blog-details">
          <img className="girl" src={girl} alt="girl" />
          <div className="industry-experts-blog-heading">
            <div className="industry-experts-blog-title"> Straight from the Experts </div>
            <div className="industry-experts-blog-subtitle">
              Want biz advice from Experts in their field? You’ve come to the right place! Browse Expert Advice pieces that span every facet of running a small business.
            </div>
            <div className="industry-experts-blog-button">
              <button onClick={openLink}>
                See All
              </button>
            </div>
          </div>
          <img className="bus" src={bus} alt="bus" />
        </div>
      </div>
      <div className="event-blog-list-arrow-buttons-container">
        { postList.length > 4 &&
          <div className="event-blog-list-arrow-buttons"> 
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
            <CommunityImg
              className="left-arrow"
              onClick={() => scrollToLeft()}
              onKeyDown={() => scrollToLeft()}
              src={rightArrow}
              alt="left arrow"
            /> 
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
            <CommunityImg
              className="right-arrow"
              onClick={() => scrollToRight()}
              onKeyDown={() => scrollToRight()}
              src={rightArrow}
              alt="right arrow"
            />
          </div>
        } 
      </div>
      <div className="industry-experts-blog-list" ref={eventBlogListRef}>
        {
          postList.map((post, idx) => {
            return <EventBlog blog={post} key={`blog-${idx}`} />
          })
        }
        <div className="industry-experts-blog-list-empty"></div>
      </div>
      
      {/* <div className="industry-experts-blog-container-border bottom" /> */}
    </>
  )
})

export default IndustryExpertsBlogs;